<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'TheOrganisation',
}
</script>

<style scoped></style>
